






































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { CodeLabel, ToiawaseFileUpload } from '@/tcw/api/types'
import { KEY_CLASS_TOIAWASE_SHUBETSU } from '@/tcw/constant/KeyClass'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import { InvalidFields } from '@/components/common/form/types'
import { AddFileInfo } from '@/components/help/types'
import ToiawaseMarkdownForm from '@/components/help/molecules/ToiawaseMarkdownForm.vue'

@Component({
  components: { ToiawaseMarkdownForm }
})
export default class ToiawaseInputForm extends Mixins(DataUpdateComponent) {
  @Prop({ default: '' })
  private title!: string
  @Prop({ default: '' })
  private shubetsu!: string
  @Prop({ default: '' })
  private naiyou!: string
  @Prop({ default: 3 })
  private kinkyudo!: string
  @Prop({ type: Boolean, default: false })
  private uploading!: boolean
  @Prop({ default: () => [] })
  private fileList!: ToiawaseFileUpload[]
  @Prop({
    default: () => {
      /** */
    }
  })
  private errorInfo!: InvalidFields

  @Emit()
  private addFiles(_addFileInfo: AddFileInfo) {
    //
  }

  private toiawaseTypes: CodeLabel[] | null = null

  private get isToiawaseTypesLoaded(): boolean {
    return this.toiawaseTypes ? this.toiawaseTypes.length > 0 : false
  }

  private mounted(): void {
    this.setLabel()
  }

  protected async setLabel(): Promise<void> {
    this.toiawaseTypes = await this.codeLabel.getCodeLabelList(KEY_CLASS_TOIAWASE_SHUBETSU)
  }
}
